import { render, staticRenderFns } from "./ImageMetadataModal.vue?vue&type=template&id=481e3d32&scoped=true"
import script from "./ImageMetadataModal.vue?vue&type=script&lang=js"
export * from "./ImageMetadataModal.vue?vue&type=script&lang=js"
import style0 from "./ImageMetadataModal.vue?vue&type=style&index=0&id=481e3d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e3d32",
  null
  
)

export default component.exports